<template>
  <div class="row document-information-content" style="justify-content: center">
    <div class="form-group editor-wrapper">
      <vue-editor
        :value="value"
        @input="$emit('input', $event)"
      ></vue-editor>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  name: "DocumentInformationContent",
  components: {
    VueEditor
  },
  props: {
    value: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.editor-wrapper {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
</style>

<style>
.document-information-content .ql-container {
  max-width: 100%;
  overflow: hidden;
}

.document-information-content .ql-editor {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
  overflow-x: hidden;
}
</style>

